module.exports = __webpack_public_path__ + "static/media/profit-loss.159d7ecc.png";